/* Sicilus Clarity fixes - safe minimal version - 21/05/2026 */
(function () {
  'use strict';

  document.addEventListener('submit', function (event) {
    window.setTimeout(function () {
      if (event.defaultPrevented || !event.submitter || event.submitter.name !== 'checkout') return;
      var form = event.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart"]')) return;
      var checkoutButton = form.querySelector('[name="checkout"]') || document.querySelector('[form="' + CSS.escape(form.id || '') + '"][name="checkout"]');
      if (!checkoutButton) return;
      checkoutButton.setAttribute('aria-busy', 'true');
      checkoutButton.classList.add('sicilus-checkout-submitting');
    }, 0);
  }, true);

  // Restore the checkout control when returning with the browser back button.
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('.sicilus-checkout-submitting').forEach(function (button) {
      button.removeAttribute('aria-busy');
      button.classList.remove('sicilus-checkout-submitting');
    });
  });

  function normalizeText(value) {
    return (value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function hasActionableText(root) {
    if (!root || root === document || root === document.documentElement) return true;
    var text = normalizeText(root.textContent);
    return text.indexOf('translation missing') !== -1 ||
      text.indexOf('general.social.links') !== -1 ||
      text.indexOf('no reviews') !== -1 ||
      text.indexOf('nessuna recensione') !== -1 ||
      text.indexOf('stock') !== -1 ||
      text.indexOf('from €') !== -1 ||
      text.indexOf('forniture horeca') !== -1 ||
      text.indexOf('horeca') !== -1 ||
      text.indexOf('shop cart account search') !== -1 ||
      text.indexOf('spedizione gratuita') !== -1 ||
      text.indexOf('spese di spedizione') !== -1;
  }

  function fixThemeTranslationLabels(root) {
    try {
      if (window.themeHDN && window.themeHDN.extras) {
        if (window.themeHDN.extras.quantity && /translation missing/i.test(window.themeHDN.extras.quantity.notAvailable || '')) {
          window.themeHDN.extras.quantity.notAvailable = 'Quantità non disponibile';
        }
        if (window.themeHDN.extras.cart) {
          if (/translation missing/i.test(window.themeHDN.extras.cart.errorMessage || '')) {
            window.themeHDN.extras.cart.errorMessage = 'Si è verificato un errore nell\'aggiornamento del carrello. Riprova.';
          }
          if (/translation missing/i.test(window.themeHDN.extras.cart.toastTitle || '')) {
            window.themeHDN.extras.cart.toastTitle = 'Carrello aggiornato';
          }
        }
      }
    } catch (e) {}

    var labels = {
      'it.products.product.quantity_not_available': 'Quantità non disponibile',
      'it.general.cart.error_message': 'Si è verificato un errore nell\'aggiornamento del carrello. Riprova.',
      'it.general.cart.toast_title': 'Carrello aggiornato'
    };

    (root || document).querySelectorAll('a, button, span, div, p').forEach(function (node) {
      var text = node.textContent || '';
      var next = text;
      Object.keys(labels).forEach(function (key) {
        next = next.replace(new RegExp('Translation missing:\\s*' + key.replace(/\./g, '\\.'), 'gi'), labels[key]);
      });
      if (next !== text && (!node.children || node.children.length === 0)) {
        node.textContent = next;
      }
    });
  }

  function fixSocialTranslationLabels(root) {
    var nodes = (root || document).querySelectorAll('a, button, span, div');
    nodes.forEach(function (node) {
      var text = normalizeText(node.textContent);
      var aria = normalizeText(node.getAttribute && node.getAttribute('aria-label'));
      var title = normalizeText(node.getAttribute && node.getAttribute('title'));

      function setLabel(label) {
        if (node.textContent && normalizeText(node.textContent).indexOf('translation missing') !== -1) {
          node.textContent = label;
        }
        if (aria.indexOf('translation missing') !== -1) node.setAttribute('aria-label', label);
        if (title.indexOf('translation missing') !== -1) node.setAttribute('title', label);
      }

      if (text.indexOf('general.social.links.whatsapp') !== -1 || aria.indexOf('general.social.links.whatsapp') !== -1 || title.indexOf('general.social.links.whatsapp') !== -1) {
        setLabel('WhatsApp');
      }
      if (text.indexOf('general.social.links.linked_in') !== -1 || text.indexOf('general.social.links.linkedin') !== -1 || aria.indexOf('general.social.links.linked_in') !== -1 || aria.indexOf('general.social.links.linkedin') !== -1 || title.indexOf('general.social.links.linked_in') !== -1 || title.indexOf('general.social.links.linkedin') !== -1) {
        setLabel('LinkedIn');
      }
    });
  }

  function hideEmptyReviewAndStockNoise(root) {
    var scope = root || document;

    scope.querySelectorAll('hdt-card-product .spr-badge-caption, hdt-card-product .jdgm-prev-badge__text, hdt-card-product .loox-rating-label').forEach(function (node) {
      var text = normalizeText(node.textContent);
      if (text === 'no reviews' || text === 'nessuna recensione' || text === '0 recensioni' || text === '0 reviews') {
        var parent = node.closest('.spr-badge, .jdgm-widget, .loox-rating, .hdt-card-product__rating') || node;
        parent.style.display = 'none';
      }
    });

    scope.querySelectorAll('hdt-card-product *').forEach(function (node) {
      var text = normalizeText(node.textContent);
      if (text === 'stock' || text === 'disponibili' || text === 'disponibile' || /^\d+\s+disponibili$/.test(text)) {
        var parent = node.closest('.hdt-stock, .hdt-pr-stock, .hdt-product-stock, .hdt-card-product__stock, .hdt-inventory') || node;
        parent.style.display = 'none';
      }
    });
  }

  function replaceOldShippingThresholdText(root) {
    var nodes = (root || document).querySelectorAll('p, li, span, div, summary, button, td, th');
    nodes.forEach(function (node) {
      if (!node.childNodes || node.childNodes.length !== 1 || node.childNodes[0].nodeType !== Node.TEXT_NODE) return;
      var value = node.textContent;
      if (!/spedizione gratuita/i.test(value) && !/spese di spedizione/i.test(value)) return;
      if (!/(75\s?€|€\s?75)/.test(value)) return;
      node.textContent = value
        .replace(/75\s?€/g, '89€')
        .replace(/€\s?75/g, '89€');
    });
  }

  function fixLiveUxCopyAndContrast(root) {
    var scope = root || document;
    var lang = (document.documentElement.getAttribute('lang') || 'it').slice(0, 2).toLowerCase();
    var i18n = {
      it: { shop: 'Catalogo', cart: 'Carrello', account: 'Profilo', search: 'Cerca', wishlist: 'Preferiti', all: 'Tutte le categorie', from: 'Da', horeca: 'Forniture HORECA', newText: '- Novita' },
      en: { shop: 'Shop', cart: 'Cart', account: 'Account', search: 'Search', wishlist: 'Wishlist', all: 'All categories', from: 'From', horeca: 'HORECA Supplies', newText: '- New' },
      fr: { shop: 'Catalogue', cart: 'Panier', account: 'Compte', search: 'Rechercher', wishlist: 'Favoris', all: 'Toutes les categories', from: 'A partir de', horeca: 'Fournitures HORECA', newText: '- Nouveaute' },
      de: { shop: 'Katalog', cart: 'Warenkorb', account: 'Konto', search: 'Suchen', wishlist: 'Favoriten', all: 'Alle Kategorien', from: 'Ab', horeca: 'HORECA-Bedarf', newText: '- Neu' },
      es: { shop: 'Catalogo', cart: 'Carrito', account: 'Cuenta', search: 'Buscar', wishlist: 'Favoritos', all: 'Todas las categorias', from: 'Desde', horeca: 'Suministros HORECA', newText: '- Novedad' },
      pt: { shop: 'Catalogo', cart: 'Carrinho', account: 'Conta', search: 'Pesquisar', wishlist: 'Favoritos', all: 'Todas as categorias', from: 'A partir de', horeca: 'Fornecimentos HORECA', newText: '- Novo' },
      nl: { shop: 'Catalogus', cart: 'Winkelwagen', account: 'Account', search: 'Zoeken', wishlist: 'Favorieten', all: 'Alle categorieen', from: 'Vanaf', horeca: 'HORECA-benodigdheden', newText: '- Nieuw' },
      sv: { shop: 'Katalog', cart: 'Varukorg', account: 'Konto', search: 'Sök', wishlist: 'Favoriter', all: 'Alla kategorier', from: 'Från', horeca: 'HoReCa-sortiment', newText: '- Nyhet' },
      pl: { shop: 'Katalog', cart: 'Koszyk', account: 'Konto', search: 'Szukaj', wishlist: 'Ulubione', all: 'Wszystkie kategorie', from: 'Od', horeca: 'Zaopatrzenie HORECA', newText: '- Nowosc' },
      cs: { shop: 'Katalog', cart: 'Kosik', account: 'Ucet', search: 'Hledat', wishlist: 'Oblibene', all: 'Vsechny kategorie', from: 'Od', horeca: 'HORECA vybaveni', newText: '- Novinka' },
      lt: { shop: 'Katalogas', cart: 'Krepselis', account: 'Paskyra', search: 'Paieska', wishlist: 'Megstamiausi', all: 'Visos kategorijos', from: 'Nuo', horeca: 'HORECA prekes', newText: '- Nauja' },
      hu: { shop: 'Katalogus', cart: 'Kosar', account: 'Fiok', search: 'Kereses', wishlist: 'Kedvencek', all: 'Osszes kategoria', from: 'Ettol', horeca: 'HORECA kellékek', newText: '- Uj' },
      no: { shop: 'Katalog', cart: 'Handlekurv', account: 'Konto', search: 'Sok', wishlist: 'Favoritter', all: 'Alle kategorier', from: 'Fra', horeca: 'HORECA-utstyr', newText: '- Nyhet' },
      ja: { shop: 'カタログ', cart: 'カート', account: 'アカウント', search: '検索', wishlist: 'お気に入り', all: 'すべてのカテゴリ', from: 'から', horeca: 'HORECA用品', newText: '- 新着' },
      uk: { shop: 'Каталог', cart: 'Кошик', account: 'Акаунт', search: 'Пошук', wishlist: 'Обране', all: 'Усі категорії', from: 'Від', horeca: 'Товари HORECA', newText: '- Новинка' }
    };
    var copy = i18n[lang] || i18n.en;

    if (!document.getElementById('sicilus-clarity-category-css')) {
      var style = document.createElement('style');
      style.id = 'sicilus-clarity-category-css';
      style.textContent = [
        '[class*="ai-category-banners__item-"]{position:relative!important;isolation:isolate!important;overflow:hidden!important;}',
        '[class*="ai-category-banners__item-"]::after{content:""!important;position:absolute!important;inset:0!important;z-index:1!important;pointer-events:none!important;background:linear-gradient(180deg,rgba(43,38,32,.10),rgba(43,38,32,.56))!important;}',
        '[class*="ai-category-banners__content-"]{position:absolute!important;left:18px!important;right:18px!important;bottom:18px!important;z-index:3!important;display:flex!important;align-items:flex-end!important;justify-content:center!important;min-height:auto!important;opacity:1!important;visibility:visible!important;transform:none!important;pointer-events:none!important;text-align:center!important;}',
        '[class*="ai-category-banners__title-"]{display:inline-block!important;opacity:1!important;visibility:visible!important;margin:0!important;padding:10px 14px!important;border-radius:6px!important;background:rgba(43,38,32,.72)!important;color:#fffaf0!important;font-family:var(--f-serif,Georgia,serif)!important;font-size:clamp(18px,2.1vw,26px)!important;line-height:1.12!important;font-weight:700!important;text-shadow:0 2px 10px rgba(0,0,0,.45)!important;}'
      ].join('');
      document.head.appendChild(style);
    }

    var labels = {
      '.hdt-toolbart-shop .hdt-toolbar-label': copy.shop,
      '.hdt-toolbart-cart .hdt-toolbar-label': copy.cart,
      '.hdt-toolbart-account .hdt-toolbar-label': copy.account,
      '.hdt-toolbart-search .hdt-toolbar-label': copy.search,
      '.hdt-toolbart-wishlist .hdt-toolbar-label': copy.wishlist
    };

    Object.keys(labels).forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (node) {
        if (node.textContent !== labels[selector]) node.textContent = labels[selector];
      });
    });

    document.querySelectorAll('[aria-label="drawer-search"], [aria-label="Search"], [aria-label="search"]').forEach(function (node) {
      node.setAttribute('aria-label', copy.search);
    });

    document.querySelectorAll('.hdt-search-input, input[type="search"], input[name="q"]').forEach(function (node) {
      if (node.hasAttribute('data-preserve-placeholder')) return;
      if (/cerca|search|rechercher|suchen|buscar|pesquisar|zoeken|sok|szukaj|hledat|paieska|kereses|検索|пошук/i.test(node.getAttribute('placeholder') || '')) {
        node.setAttribute('placeholder', copy.search + ' Sicilus.com');
      }
    });

    document.querySelectorAll('button, input[type="submit"], .hdt-search-form__submit').forEach(function (node) {
      var value = node.value || node.textContent || '';
      if (/^\s*(cerca|search|rechercher|suchen|buscar|pesquisar|zoeken|sok|szukaj|hledat|paieska|kereses|検索|пошук)\s*$/i.test(value)) {
        if (node.value) node.value = copy.search;
        if (node.textContent) node.textContent = copy.search;
      }
    });

    document.querySelectorAll('[class*="ai-category-banners__title-"]').forEach(function (node) {
      var text = (node.textContent || '').replace(/\s+/g, ' ').trim();
      if (/Forniture\s+Horeca/i.test(text) || text === 'Forniture HORECA') {
        node.textContent = copy.horeca;
      }
      node.style.setProperty('display', 'inline-block', 'important');
      node.style.setProperty('visibility', 'visible', 'important');
      node.style.setProperty('opacity', '1', 'important');
      node.style.setProperty('color', '#fffaf0', 'important');
      node.style.setProperty('background', 'rgba(43,38,32,.72)', 'important');
    });

    var pattern = /From\s*€|Da\s*€|A partir de\s*€|Ab\s*€|Desde\s*€|Vanaf\s*€|Fran\s*€|Od\s*€|Nuo\s*€|Ettol\s*€|Fra\s*€|Forniture Horeca|Forniture HORECA|Horeca|HORECA Supplies|HORECA-Bedarf|Fournitures HORECA|Suministros HORECA|\(New\)|- Novita|- New/;
    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var parent = node.parentElement;
        if (!parent || /^(SCRIPT|STYLE|TEXTAREA|INPUT|NOSCRIPT)$/i.test(parent.tagName)) return NodeFilter.FILTER_REJECT;
        return pattern.test(node.nodeValue || '') ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });

    var node;
    while ((node = walker.nextNode())) {
      var text = node.nodeValue;
      var next = text
        .replace(/\bForniture Horeca\b/g, copy.horeca)
        .replace(/\bForniture HORECA\b/g, copy.horeca)
        .replace(/\bHORECA Supplies\b/g, copy.horeca)
        .replace(/\bFournitures HORECA\b/g, copy.horeca)
        .replace(/\bHORECA-Bedarf\b/g, copy.horeca)
        .replace(/\bSuministros HORECA\b/g, copy.horeca)
        .replace(/\bHoreca\b/g, 'HORECA')
        .replace(/\b(?:From|Da|A partir de|Ab|Desde|Vanaf|Fran|Od|Nuo|Ettol|Fra)\s*(€\s*[0-9.,]+)/g, copy.from + ' $1')
        .replace(/\b(?:From|Da|A partir de|Ab|Desde|Vanaf|Fran|Od|Nuo|Ettol|Fra)\s*(€[0-9.,]+)/g, copy.from + ' $1')
        .replace(/\(New\)|- Novita|- New/g, copy.newText);

      if (next !== text) node.nodeValue = next;
    }
  }

  function protectCartDrawerSectionRendering() {
    if (window.__sicilusCartDrawerSectionFix) return;
    window.__sicilusCartDrawerSectionFix = true;

    var originalFetch = window.fetch;
    if (typeof originalFetch !== 'function') return;

    function shopRoot() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    }

    function isCartPageUrl(value) {
      try {
        var url = new URL(value, window.location.origin);
        var path = url.pathname.replace(/\/+$/, '');
        return /\/cart$/i.test(path);
      } catch (e) {
        return false;
      }
    }

    if (isCartPageUrl(window.location.href)) return;

    function isCartAjaxUrl(value) {
      try {
        var url = new URL(value, window.location.origin);
        return /\/cart\/(add|change|update|clear)(\.js)?$/i.test(url.pathname);
      } catch (e) {
        return false;
      }
    }

    function isCartDrawerSectionUrl(value) {
      try {
        var url = new URL(value, window.location.origin);
        return url.searchParams && url.searchParams.get('section_id') === 'cart-drawer';
      } catch (e) {
        return false;
      }
    }

    function includesCartDrawerSection(sections) {
      if (!sections) return false;
      if (Array.isArray(sections)) return sections.indexOf('cart-drawer') !== -1;
      return String(sections).split(',').indexOf('cart-drawer') !== -1 || String(sections).indexOf('cart-drawer') !== -1;
    }

    function safeRootSectionsUrl() {
      return shopRoot();
    }

    window.fetch = function (input, init) {
      var requestUrl = typeof input === 'string' ? input : (input && input.url) || '';
      var shouldInspect = isCartAjaxUrl(requestUrl) || isCartDrawerSectionUrl(requestUrl);

      if (!shouldInspect) {
        return originalFetch.call(this, input, init);
      }

      var nextInput = input;
      var nextInit = init;

      if (isCartAjaxUrl(requestUrl) && init && typeof init.body === 'string') {
        try {
          var payload = JSON.parse(init.body);
          if (payload && includesCartDrawerSection(payload.sections) && isCartPageUrl(payload.sections_url)) {
            payload.sections_url = safeRootSectionsUrl();
            nextInit = Object.assign({}, init, { body: JSON.stringify(payload) });
          }
        } catch (e) {
          // Keep the original request untouched if the body is not JSON.
        }
      }

      if (typeof input === 'string' && isCartDrawerSectionUrl(input)) {
        try {
          var directUrl = new URL(input, window.location.origin);
          if (isCartPageUrl(directUrl.href)) {
            var rootPath = shopRoot();
            directUrl.pathname = rootPath;
            nextInput = directUrl.pathname + directUrl.search + directUrl.hash;
          }
        } catch (e) {
          // Keep the original URL untouched.
        }
      }

      var responsePromise = originalFetch.call(this, nextInput, nextInit);

      return responsePromise;
    };
  }

  function initSicilusClarityFunnelTracking() {
    if (window.__sicilusClarityFunnelTracking) return;
    window.__sicilusClarityFunnelTracking = true;

    function callClarity(action, key, value) {
      try {
        if (!clarityReady()) return;
        if (action === 'event') window.clarity('event', key);
        if (action === 'set') window.clarity('set', key, value);
      } catch (e) {}
    }

    function sendEvent(name) {
      if (!name) return;
      callClarity('event', name);
    }

    function setTag(key, value) {
      if (!key || value === undefined || value === null || value === '') return;
      callClarity('set', key, String(value).slice(0, 80));
    }

    function pageType() {
      var path = window.location.pathname.replace(/\/+$/, '') || '/';
      if (/\/cart$/i.test(path)) return 'cart';
      if (/\/products\//i.test(path)) return 'product';
      if (/\/collections\//i.test(path)) return 'collection';
      if (/\/search$/i.test(path)) return 'search';
      if (path === '/' || /^\/[a-z]{2}(?:-[a-z]{2})?$/i.test(path)) return 'home';
      return 'other';
    }

    function familyFromText(value) {
      var text = normalizeText(value);
      if (/brioche|brioscia|tuppo/.test(text)) return 'brioche';
      if (/cannoli|cialde|cannolo/.test(text)) return 'cannoli';
      if (/bibite|bevande|drink|bona|chinotto|aranciata|limonata/.test(text)) return 'bibite';
      if (/fragile|ordinazione|preorder|imballo|imballaggio|packaging|horeca|professionale|forniture/.test(text)) return 'speciale';
      if (/panettone|colomba|pistacchio|mandorla|olio|dolci|pasta|sugo|conserve/.test(text)) return 'standard';
      return 'unknown';
    }

    function textFromClosest(node) {
      var target = node && node.closest && node.closest('form, hdt-card-product, .product, .hdt-product, .cart-item, .hdt-cart-item, main');
      return [
        document.title,
        window.location.pathname,
        target ? target.textContent : ''
      ].join(' ');
    }

    function cartHasSpecialProducts() {
      var text = normalizeText((document.querySelector('main') || document.body || document.documentElement).textContent);
      return /prodotti speciali|non contribuiscono|tariffe separate|brioche|cannoli|cialde|bibite|fragile|ordinazione|imballo/.test(text);
    }

    function tagCurrentPage() {
      var type = pageType();
      setTag('sicilus_page_type', type);

      if (type === 'product') {
        var family = familyFromText([document.title, window.location.pathname, document.body ? document.body.textContent : ''].join(' '));
        setTag('sicilus_product_family', family);
        sendEvent('sicilus_product_view');
      }

      if (type === 'collection') {
        setTag('sicilus_collection_family', familyFromText([document.title, window.location.pathname].join(' ')));
      }

      if (type === 'cart') {
        sendEvent('sicilus_cart_page_view');
        setTag('sicilus_cart_contains_special', cartHasSpecialProducts() ? 'yes' : 'no');
      }
    }

    function bindFunnelClicks() {
      document.addEventListener('click', function (event) {
        var target = event.target && event.target.closest ? event.target.closest('a, button, input, summary') : null;
        if (!target) return;

        var label = normalizeText([
          target.textContent,
          target.getAttribute && target.getAttribute('aria-label'),
          target.getAttribute && target.getAttribute('name'),
          target.getAttribute && target.getAttribute('href')
        ].join(' '));

        var associatedForm = target.form || (target.closest && target.closest('form'));
        var isSubmit = (target.tagName === 'BUTTON' && (!target.type || target.type === 'submit')) ||
          (target.tagName === 'INPUT' && /^(submit|image)$/i.test(target.type));
        var addForm = associatedForm && /\/cart\/add(?:\.js)?(?:[?#]|$)/i.test(associatedForm.getAttribute('action') || '');
        if (isSubmit && addForm) {
          sendEvent('sicilus_add_to_cart_click');
          setTag('sicilus_add_to_cart_family', familyFromText(textFromClosest(target)));
          return;
        }

        var href = target.getAttribute('href') || '';
        var isCheckoutLink = false;
        try { isCheckoutLink = target.tagName === 'A' && /\/checkouts?(?:\/|$)/i.test(new URL(href, location.origin).pathname); } catch (e) {}
        if ((isSubmit && target.name === 'checkout') || isCheckoutLink) {
          sendEvent('sicilus_begin_checkout_click');
          setTag('sicilus_checkout_has_special_products', cartHasSpecialProducts() ? 'yes' : 'no');
          return;
        }

        if (/\/cart($|\?)/.test(label) || /carrello|cart/.test(label)) {
          sendEvent('sicilus_cart_intent');
        }

        if (/remove|rimuovi|elimina|cancella/.test(label)) {
          sendEvent('sicilus_remove_from_cart_click');
        }
      }, true);

      document.addEventListener('submit', function (event) {
        var form = event.target;
        if (!form || !form.matches) return;
        if (form.matches('form[action*="/cart/add"]')) {
          sendEvent('sicilus_add_to_cart_submit');
          setTag('sicilus_add_to_cart_family', familyFromText(textFromClosest(form)));
        }
        if (form.matches('form[action*="/cart"]') && event.submitter && event.submitter.name === 'checkout') {
          sendEvent('sicilus_begin_checkout_submit');
          setTag('sicilus_checkout_has_special_products', cartHasSpecialProducts() ? 'yes' : 'no');
        }
      }, true);
    }

    window.__sicilusTrackCartFetch = function (requestUrl, ok) {
      if (/\/cart\/add(\.js)?/i.test(requestUrl)) sendEvent(ok ? 'sicilus_cart_add_success' : 'sicilus_cart_add_error');
      if (/\/cart\/(change|update|clear)(\.js)?/i.test(requestUrl)) sendEvent(ok ? 'sicilus_cart_update_success' : 'sicilus_cart_update_error');
      if (/section_id=cart-drawer/i.test(requestUrl)) sendEvent(ok ? 'sicilus_cart_drawer_fetch_success' : 'sicilus_cart_drawer_fetch_error');
    };

    // Observe cart requests independently of the off-cart drawer rendering fix.
    if (!window.__sicilusClarityCartObserver && typeof window.fetch === 'function') {
      window.__sicilusClarityCartObserver = true;
      var trackingFetch = window.fetch;
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
        var isMutation = false;
        try {
          var parsed = new URL(url, location.origin);
          isMutation = parsed.origin === location.origin && method === 'POST' &&
            /\/cart\/(add|change|update|clear)(\.js)?$/i.test(parsed.pathname);
        } catch (e) {}
        var result = trackingFetch.apply(this, arguments);
        if (isMutation) result.then(function (response) {
          window.__sicilusTrackCartFetch(url, response.ok);
        }, function () { window.__sicilusTrackCartFetch(url, false); });
        return result;
      };
    }

    var pageTagged = false;
    var readinessTimer = null;
    var readinessAttempts = 0;

    function clarityReady() {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      try {
        if (privacy && typeof privacy.analyticsProcessingAllowed === 'function' &&
            !privacy.analyticsProcessingAllowed()) return false;
      } catch (error) { return false; }
      return typeof window.clarity === 'function';
    }

    function tagWhenReady() {
      if (readinessTimer !== null) window.clearTimeout(readinessTimer);
      readinessTimer = null;
      if (pageTagged || document.visibilityState === 'hidden') return;
      if (clarityReady()) {
        pageTagged = true;
        tagCurrentPage();
        return;
      }
      readinessAttempts += 1;
      readinessTimer = window.setTimeout(tagWhenReady, readinessAttempts < 60 ? 500 : 5000);
    }

    document.addEventListener('visitorConsentCollected', tagWhenReady);
    document.addEventListener('visibilitychange', tagWhenReady);
    window.addEventListener('pageshow', tagWhenReady);
    window.addEventListener('pagehide', function () {
      if (readinessTimer !== null) window.clearTimeout(readinessTimer);
      readinessTimer = null;
    });
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', tagWhenReady, { once: true });
    } else {
      tagWhenReady();
    }

    bindFunnelClicks();
  }

  initSicilusClarityFunnelTracking();
  protectCartDrawerSectionRendering();

  function runSicilusOperationalFixes(root) {
    fixLiveUxCopyAndContrast(root || document);
    if (!hasActionableText(root)) return;
    fixThemeTranslationLabels(root);
    fixSocialTranslationLabels(root);
    hideEmptyReviewAndStockNoise(root);
    replaceOldShippingThresholdText(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { runSicilusOperationalFixes(document); });
  } else {
    runSicilusOperationalFixes(document);
  }

  window.setTimeout(function () { runSicilusOperationalFixes(document); }, 500);
  window.setTimeout(function () { runSicilusOperationalFixes(document); }, 1500);
  window.setTimeout(function () { runSicilusOperationalFixes(document); }, 3000);

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node && node.nodeType === 1) runSicilusOperationalFixes(node);
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
